<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form #form [form]="formInput">
        </sm-form>
        <p-button class="mt-2" icon="fas fa-run" label="Starten" (onClick)="run()"></p-button>
    </p-panel>
    <div class="flex-item-fill flex-col">
        <sm-toolbar>
            <p-checkbox class="mr-3" label="Zeit" name="displayTime" [(ngModel)]="displayTime" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
            <p-checkbox class="mr-3" label="Objektmenge" name="displayObjectCount" [(ngModel)]="displayObjectCount" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
            <p-checkbox class="mr-3" label="Interne Verzeichnisse" name="displayInternalFolders" [(ngModel)]="displayInternalFolders" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
            <p-checkbox class="mr-3" label="Sim Log" name="displaySimLog" [(ngModel)]="displaySimLog" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
            <p-checkbox class="mr-3" label="Meistverarbeitetes Objekt" name="displayMostUsedObjects" [(ngModel)]="displayMostUsedObjects" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
            <p-checkbox label="Anderes" name="displayOther" [(ngModel)]="displayOther" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
        </sm-toolbar>
        <sm-table2 *ngIf="tableData != null" class="flex-item-fill height100p" [data]="tableData"></sm-table2>
    </div>
</div>
